import React from 'react'
import { getState, arrayFrom, isEmpty } from '../twd'
import { useTreasuryAuctions } from './use-treasury-auctions'

const state = getState('treasury-auctions.schedules', {
    tab: 'bills',
})

export default () => {

    const [tab, setTab_] = React.useState(state.value.tab || 'bills')
    const setTab = React.useCallback((m) => {
        state.set({tab:m})
        setTab_(m)
    }, [])

    return <React.Fragment>
    <div className="row vertical-offset-xs"></div>

    <div className="row">
    <div className="col-xs-12">
        <div className="medium-header">Treasury auction schedules</div>
    </div>
    </div>
    <Tabs tab={tab} setTab={setTab} />

    <Table tab={tab} />

    {tab==='bills' &&
        <div className="row vertical-offset-sm"><div className="col-xs-12">
        Cash Management Bills (CMBs) are not auctioned on an established schedule;
        they are offered as needed by the Treasury to manage cash flows.
        </div></div>}

    <div className="row vertical-offset-sm"><div className="col-xs-12">
        The treasury auction schedule is subject to change, and may be impacted by market holidays.
        Please reference <a href="https://treasurydirect.gov/auctions/when-auctions-happen/"
            target="_blank"
            style={{textDecoration:'underline'}}>this page</a> for current information.
    </div></div>
    </React.Fragment>
}

const Tabs = ({tab, setTab}) =>
    <div className="row vertical-offset-sm"><div className="col-xs-12">
    <div className="nav-tabs nav-tabs-border">
    <ul>
        <li className={tab==='bills' ? 'active' : ''}>
        <button
            className="subhead"
            onClick={() => setTab('bills')}>Bills</button>
        </li>
        <li className={tab==='notes' ? 'active' : ''}>
        <button
            className="subhead"
            onClick={() => setTab('notes')}>Notes</button>
        </li>
        <li className={tab==='bonds' ? 'active' : ''}>
        <button
            className="subhead"
            onClick={() => setTab('bonds')}>Bonds</button>
        </li>
        <li className={tab==='tips' ? 'active' : ''}>
        <button
            className="subhead"
            onClick={() => setTab('tips')}>TIPS</button>
        </li>
        <li className={tab==='frns' ? 'active' : ''}>
        <button
            className="subhead"
            onClick={() => setTab('frns')}>FRNs</button>
        </li>
    </ul>
    </div>
    </div></div>


const Table = ({tab}) => {
    const { schedules } = useTreasuryAuctions()

    const rs = schedules.filter(({type}) => (type || '').toLowerCase()===tab)

    const hasSchedules = !isEmpty(rs)

    if (!hasSchedules) return <EmptyMsg />

    return <React.Fragment>
    <div className="row">
    <div className="col-xs-12 table-responsive">
        <table className="table">
        <thead>
            <tr>
            <th>Term</th>
            <th>Auction<br/>frequency</th>
            <th>Announcement<br/>day</th>
            <th>Auction day</th>
            <th>Issue day</th>
            </tr>
        </thead>
        <tbody>
            { arrayFrom(rs)
                .map(({term, auctionFrequency, announcementDay, auctionDay, issueDay},i) => {
                    return <tr key={i}>
                        <td>{term}</td>
                        <td>{auctionFrequency}</td>
                        <td>{announcementDay}</td>
                        <td>{auctionDay}</td>
                        <td>{issueDay}</td>
                    </tr>
                })
            }
        </tbody>
        </table>
    </div>
    </div>
    </React.Fragment>

}


const EmptyMsg  = () =>
    <div className="col-md-12 text-center">
    <i className="et-icon et-alert et-icon-md" aria-hidden="true"></i>
    <div className="small-header">There are currently no upcoming Treasury auctions.</div>
    <p>Check the upcoming auctions table for the tentative schedule.</p>
    </div>


// WEBPACK FOOTER //
// ./src/treasury-auctions/schedules.js